// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1DuK7","unreadBadge":"styles_unreadBadge__3TpxC","modalContent":"styles_modalContent__3I_Um","modal":"styles_modal__4YLZK"};